import blogService from "@/api/services/blogService";
import { defineStore } from "pinia";
import { BlogPostResponse } from "@/interfaces/Blog/BlogPostResponse.ts";

interface BlogPostState {
  posts: Record<string, BlogPostResponse>;
}

export const useBlogPostStore = defineStore("blogPost", {
  state: (): BlogPostState => ({
    posts: {},
  }),

  getters: {
    getBlogPost: (state: BlogPostState) => (alias: string) => state.posts[alias] || null,
  },

  actions: {
    setBlogPost(alias: string, post: BlogPostResponse) {
      this.posts[alias] = post;
    },
    async fetchBlogPost(alias: string, lang: string): Promise<BlogPostResponse> {
      const postData = await blogService.getPost(lang, alias);
      this.setBlogPost(alias, postData);
      return postData;
    },
  },
});
